import {
  BellOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Badge, Button, List, Pagination, Popover, theme } from "antd";
import { MessagesByProducer } from "../../../../../../interfaces/services/get-messages-by-producer-service";
import { useContext, useEffect, useState } from "react";
import HomeService from "../../../../../../services/home";
import { NOTIFICATION_STATUS } from "../../utils/notification-status.enum";
import { COLORS } from "../../../../../../../config/themes/colors";
import "./index.css";
import dayjs from "dayjs";
import { AuthContext } from "../../../../../../contexts";

export const Notifications = () => {
  const {
    token: { colorWhite },
  } = theme.useToken();
  const [notificationNumber, setNotificationNumber] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [userNotifications, setUserNotifications] = useState<
    MessagesByProducer[]
  >([]);
  const pageSize = 5;
  const paginatedData = userNotifications.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const [popoverVisible, setPopoverVisible] = useState(false);
  const authContext = useContext(AuthContext);

  const fetchNotifications = () => {
    HomeService.getUserNotifications()
      .then((res) => {
        setUserNotifications(res.mensajesPorProductor);
      })
      .catch((err) => {});
  };

  useEffect(() => {        
    if(authContext.userInfo?.intermediarioPrincipal && !userNotifications.length){
      fetchNotifications();
    }
  }, [authContext.userInfo]);

  useEffect(() => {
    let index = 0;
    userNotifications.forEach((item) => {
      if (item.status === NOTIFICATION_STATUS.NOT_READ) {
        index = index + 1;
      }
    });
    setNotificationNumber(index);
  }, [userNotifications]);

  const updateNotificationStatus = (idMessage: string, action: string) => {
    if (action === NOTIFICATION_STATUS.NOT_READ) {
      action = NOTIFICATION_STATUS.READ;
    } else {
      action = NOTIFICATION_STATUS.NOT_READ;
    }
    HomeService.updateNotificationStatus(idMessage, action)
      .then(() => {
        setUserNotifications((prevNotifications) => {
          return prevNotifications.map((item) => {
            if (item.idMensaje === idMessage) {
              return {
                ...item,
                status: action,
              };
            }
            return item;
          });
        });
      })
      .catch(() => {});
  };

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={popoverVisible}
      onOpenChange={(visible) => setPopoverVisible(visible)}
      overlayInnerStyle={{ padding: "0px 0px 12px 0px", maxWidth: "400px" }}
      content={
        <>
          <List
            itemLayout="horizontal"
            dataSource={paginatedData}
            renderItem={(item, index) => (
              <List.Item
                onClick={() => {
                  updateNotificationStatus(item.idMensaje, item.status);
                  setPopoverVisible(false);
                }}
                style={{
                  backgroundColor:
                    item.status === NOTIFICATION_STATUS.NOT_READ
                      ? COLORS.neutrals[0]
                      : COLORS.neutrals[15],
                  maxWidth: "400px",
                }}
                className={`header_notification-item ${
                  index === 0 ? "header_notification-item-first" : ""
                }`}
              >
                <div
                  className={`header_notifications-container ${
                    item.status === NOTIFICATION_STATUS.NOT_READ
                      ? "header_notifications-not-read"
                      : ""
                  }`}
                >
                  <div
                    className={`header_notification-rectangle ${
                      index === 0 ? "header_first-notification" : ""
                    }`}
                    style={{
                      backgroundColor:
                        item.status === NOTIFICATION_STATUS.NOT_READ
                          ? COLORS.primary[100]
                          : COLORS.neutrals[50],
                    }}
                  />
                  <div className="header_notification-text">
                    {item.mensaje}
                  </div>
                </div>
                <div className="header_notification-date-container">
                  <div className="header_notification-date">
                    {dayjs(item.fechaMensaje).format("MM/YY")}
                  </div>
                  <div>
                    {item.status === NOTIFICATION_STATUS.NOT_READ ? (
                      <EyeInvisibleOutlined />
                    ) : (
                      <EyeOutlined />
                    )}
                  </div>
                </div>
              </List.Item>
            )}
          />
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={userNotifications.length}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
            className="header_notification-pagination"
            showLessItems={true}
          />
        </>
      }
    >
      <Button
        type="text"
        icon={
          <Badge size="small" count={notificationNumber} overflowCount={99}>
            <BellOutlined style={{ color: colorWhite }} />
          </Badge>
        }
        className="header_notification-button"
      />
    </Popover>
  );
};
